import { getAppointCacheData } from "./getRestClassify.js"
import { replaceUrlParam, getSwData, formatterDateHandle, getErrorCode, getQueryParam, parseQueryString, getDocumentCookie } from "utils/index"
//检查当前非缓存组件的restDataUrl是否为最新的，防止在模板中出现数据无法响应的问题
export async function checkAppId(rectAttr) {
  const { pageId: publicPageId, wfwfid, websiteId } = this.$store.state.states.getDataPageIds
  //pageid兼容 大屏轮播页需要不同pageid的页面内的组件使用不同pageid
  let pageId
  if (this?.myid?.pageId) {
    pageId = this.myid.pageId
  } else {
    pageId = publicPageId
  }
  //兼容结束
  // let appId = rectAttr.appId || rectAttr?.options?.appId
  // 如果rectAttr.appId和rectAttr.options.appId不一样，以rectAttr.options.appId为准
  // if (rectAttr.appId !== rectAttr?.options?.appId) {
  //   appId = rectAttr?.options?.appId
  // }
  const appId = rectAttr?.options?.appId || rectAttr.appId
  if (appId?.length) {
    const { restDataUrl, restUrl, engineInstance, dataCenterContent } = await getAppointCacheData.call(
      this,
      pageId,
      wfwfid,
      websiteId,
      appId
    )
    const typeId = restUrl.data.data.generalDataTypes[0] ? restUrl.data.data.generalDataTypes[0].publicId : ""
    const _restDataUrl = replaceUrlParam(restDataUrl, "t", typeId ? typeId : "")
    !this.isBigScreenPreview() && this.$changeOptionsEV(_restDataUrl, "restDataUrl", false, null, this.myid)
    if (!this.isBigScreenPreview() && engineInstance) {
      const innerElement = rectAttr?.options?.innerElement || rectAttr?.innerElement
      if (innerElement === "cxTable") {
        // 存储数据推送需要的参数
        this.$changeOptionsEV(engineInstance.id, "engineInstanceId_10", false, null, this.myid)
      }
    }
    return { restDataUrl: _restDataUrl, dataCenterContent }
  } else return ""
}
export async function updateNormalRect(updateCb, pageSize, pageNum, dateVal) {
  return new Promise((resolve, reject) => {
    const ids = { ...(this.myid || this.ids) }
    let type = "rect"
    //1--兼容在布局组件或在轮播组件内的组件单独绑定数据的逻辑
    // if (ids.elementInAutoLayoutId !== null && ids.elementInAutoLayoutId !== undefined) {
    //   type = "elementInAutoLayout"
    // }
    // if (ids.directionIndex !== null && ids.directionIndex !== undefined) {
    //   type = "elementInTitleOptions"
    // }
    // if (ids.elementInLayoutId !== null && ids.uid !== null && !isNaN(ids.elementInLayoutId) && ids.uid !== undefined) {
    //   type = "elementInLayout"
    // }
    // if (
    //   ids.swiperContent_id !== null &&
    //   ids.elementInSwiperId !== null &&
    //   !isNaN(ids.elementInSwiperId) &&
    //   !isNaN(ids.swiperContent_id)
    // ) {
    //   type = "elementInSwiper"
    // }
    //122兼容结束
    const rectAttr = this.getAttrById(this.$store.state[this.request_prefix], ids)
    const opt = rectAttr.options ? rectAttr.options : rectAttr
    const { appId, restDataUrl } = opt
    if (!rectAttr) return
    if (opt.detailFieldMapping?.fieldFlag && opt.detailFieldMapping?.isChecked) {
      const { textContent, textLink, linkUrl } = { ...getDetailPageTextContent.call(this, opt.detailFieldMapping) }
      textContent && updateCb(textContent, linkUrl)
      !textContent && updateCb("")
      let params = {
        ...ids,
        option_name: "linkUrl",
        option_val: textLink ? textLink : ""
      }
      !linkUrl && this.$store.dispatch(this.request_prefix + "/changeOptions", params)
      resolve()
    } else {
      //是全量接口的数据就从全量接口中拿 否则就走老流程
      this.asyncTask
        .checkAppId(appId)
        .then(res => {
          res?.datas?.length && updateCb(res.datas, res)
          resolve(restDataUrl, res)
        })
        .catch(err => {
          // allRequest里没这个appid的数据 allRequest请求报错 allRequest过期了
          getAppData.call(this, rectAttr, pageSize, pageNum, dateVal, updateCb, resolve, reject)
        })
    }
  })
}
async function getAppData(rectAttr, pageSize, pageNum, dateVal, updateCb, resolve, reject) {
  let { restDataUrl, dataCenterContent } = await checkAppId.call(this, rectAttr) //获取真实restDataUrl
  if (restDataUrl?.length) {
    const opt = rectAttr.options ? rectAttr.options : rectAttr
    const { hasSearch, filterValue } = opt
    //组件内部的搜索功能的后台搜索参数优先级要高于跨页面传参的优先级
    // let swData = encodeURIComponent(hasSearch && filterValue ? filterValue : decodeURIComponent(getSwData(opt)))
    let swData = encodeURIComponent(hasSearch && filterValue ? filterValue : '')
    //暂时的特殊处理：下拉框在大屏预览页的参数不编译，避免中文参数被编译接口取不到值
    if(this.isBigScreenPreview() && opt.innerElement === "cxSelect" && hasSearch && !opt.encryptSearchQuery){
      // swData = decodeURIComponent(swData)
      swData = hasSearch && filterValue ? filterValue : decodeURIComponent(getSwData(opt))
    }
    if (dateVal?.length) {
      /*日期联动选择*/
      restDataUrl =
        replaceUrlParam(restDataUrl, "sd", dateVal[2]) +
        "&sf=" +
        dateVal[0] +
        "&ed=" +
        dateVal[3] +
        "&ef=" +
        dateVal[1]
    }
    // 不需要单独接口查数据中心筛选条件，从restclassify接口获取
    if(dataCenterContent?.params) {
      const params = parseQueryString(dataCenterContent.params)
      let express = params.express
      const arr = []
      if(express && Array.isArray(express)) {
        express.forEach(item => {
          if (item.valueType === "CURR_PAGE_FIELD") {
            // 链接参数
            if (item.val === "999999" && item.linkVal && getQueryParam(item.linkVal)) {
              arr.push({
                id: item.linkVal,
                val: getQueryParam(item.linkVal)
              })
            } else if (item.val === "888888" && item.linkVal && getDocumentCookie(item.linkVal)) {
              arr.push({
                id: item.linkVal,
                val: getDocumentCookie(item.linkVal),
                type: "cookie"
              })
            } else if (item.val && item.val !== "999999" && item.val !== "888888") {
              let detailData = localStorage.getItem("detailData")
              detailData = detailData ? JSON.parse(detailData)[0] : {}
              for (let key in detailData) {
                if (detailData[key] && detailData[key].srcFlag === item.val && detailData[key].value) {
                  arr.push({
                    id: item.val,
                    val: detailData[key].value
                  })
                }
              }
            }
          }
        })
        if (arr.length > 0) {
          let params = JSON.stringify(arr)
          if (params) {
            restDataUrl = replaceUrlParam(restDataUrl, "params", encodeURIComponent(params))
          }
        }
      }
    }
    /* 此处是为了实现接收sw参数请求接口 */
    let needSw = false
    // 编辑页不需要传sw参数--梦蝶
    // if(opt.pluginName){
    //   needSw = filterPluginName(opt.pluginName)
    // }
    // if(needSw){
    //   console.log("opt.pluginName",opt.pluginName)
    //   if(restDataUrl.indexOf("sw=") !== -1){
    //     // todo
    //     restDataUrl = restDataUrl + encodeURIComponent(getSwData(opt))
    //   } else {
    //     restDataUrl = restDataUrl + (restDataUrl.indexOf("?") === -1 ? "?sw=" : "&sw=") + encodeURIComponent(getSwData(opt))
    //   }
    // }
    console.log("22222",restDataUrl + swData + (pageNum ? "&p=" + pageNum : "") + (pageSize ? "&p2=" + pageSize : ""))
    const res = await this.asyncTask.add(
      this.instance.get(restDataUrl + swData + (pageNum ? "&p=" + pageNum : "") + (pageSize ? "&p2=" + pageSize : ""))
    )
    this.$changeOptionsEV("", "errorCode", false, null, this.myid)
    // 错误码
    if (this.request_prefix !== "bigScreen" && (res?.data?.status !== 200 || res?.data?.code === 0)) {
      let errorCode = getErrorCode(res?.data?.message)
      console.log('errorCode :>>',res?.data?.message, errorCode);
      this.$changeOptionsEV(errorCode, "errorCode", false, null, this.myid)
    }
    let datas = res?.data?.data?.datas?.datas
    let totalRecords = res?.data?.data?.datas?.totalRecords
    if (dateVal?.length) {// 传了日期返回的数据结构不一样
      datas = res?.data?.data?.datas
      totalRecords = datas.length
    }
    if (opt.getDataCount && typeof Number(totalRecords) === "number" && !isNaN(totalRecords)) {
      updateCb([{ 0: { key: "数据总数量", value: totalRecords } }])
      resolve(restDataUrl)
      // } else if (datas && datas.length) {
    } else if (datas) {
      updateCb(datas, totalRecords)
      resolve(restDataUrl)
    } else reject("接口数据为空")
  }
}

function getDetailPageTextContent(mapping) {
  let textContent = null
  let textLink = null
  let linkUrl = null
  // 需要区分当前页面的类型
  // 1. 如果是详情页，那么就从detailData缓存中取数据
  // 2. 如果是列表页，那么就从classifyData缓存中取数据
  const pageType = this.$store.state[this.request_prefix].type
  const appId = this.$store.state.states.getDataPageIds.appId
  let detailData = []
  if (pageType === "detailPage" && window.localStorage.getItem("detailData")) {
    detailData = JSON.parse(window.localStorage.getItem("detailData"))[0]
  }
  if (pageType === "listPage" && window.localStorage.getItem("classifyDetailData-" + appId)) {
    detailData = JSON.parse(window.localStorage.getItem("classifyDetailData-" + appId))[0]
  }
  if (detailData) {
    if (mapping.isChecked) {
      // 绑定字段优先按照srcFlag绑定，不存在时，按照历史逻辑处理
      const isSrcFieldBinding = !!mapping.fieldSrcFlag
      const isSrcLinkBinding = !!mapping.linkSrcField
      Object.keys(detailData).forEach(key => {
        if (isSrcLinkBinding ? (detailData[key] && detailData[key].srcFlag === mapping.linkSrcField) : (key === mapping.linkField)) {
          linkUrl = detailData[key].value
        }
        if (isSrcFieldBinding ? (detailData[key] && detailData[key].srcFlag === mapping.fieldSrcFlag) : (key === mapping.fieldFlag)) {
          // 增加日期格式判断，如果是日期字段，需要走日期格式化方法
          let detailDataKeyValue = detailData[key].value
          if(mapping.isDate){
            detailDataKeyValue = formatterDateHandle(detailDataKeyValue, mapping.dateStyle, mapping.dateTitle, detailData[key].key)
          }
          if (mapping.dataType === "dataKey") {
            // textContent = detailData[key].key
            // 针对详情页如 作者:**  这个需要拖两个组件的合并 和产品确认，这种情况不需要设置两个样式
            textContent = detailData[key].key + "：" + detailDataKeyValue
            // 视频详情
            if (mapping.fieldFlag === "videoObjectId") {
              textContent = {
                objectId: detailData[key],
                videoCover: detailData.videoCoverUrl
              }
            }
          }
          if (mapping.dataType === "dataValue") {
            textContent = detailDataKeyValue
          }
          if (mapping.dataType === "dataName") {
            textContent = detailData[key].key
            // 附件地址放到url里的
            if (detailData[key].url) {
              textLink = detailData[key].url
            } else {
              textLink = detailDataKeyValue
            }
          }
          // 从云盘上传的视频 要取objectid
          if (mapping.dataType === "dataObjectId") {
            textContent = detailData[key].objectId
          }
        }
      })
      return {
        textContent: textContent,
        textLink: textLink,
        linkUrl
      }
    }
  }
}
function filterPluginName(pluginName) {
  let pluginArr = ["getSelectValuePlugin", "getUidValuePlugin", "layoutRelativeGetPlugin"]
  return pluginName.some(value => pluginArr.includes(value))
}
